var _circle, _path, _path2, _rect, _rect2, _rect3, _rect4, _circle2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPublishedPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_12029_80955)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3903 4.97683L10.9666 5.55361C10.4328 5.56162 10.0065 6.00088 10.0145 6.53472L10.578 44.0762C10.5861 44.61 11.0253 45.0363 11.5592 45.0283L49.9829 44.4515C50.5167 44.4435 50.943 44.0043 50.935 43.4704L50.3714 5.92892C50.3634 5.39508 49.9242 4.96882 49.3903 4.97683Z",
    fill: "#5E6974"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6194 4.49726L11.451 5.07021C10.9171 5.07822 10.4909 5.51748 10.4989 6.05132L11.0624 43.5928C11.0704 44.1266 11.5097 44.5529 12.0435 44.5449L50.2119 43.972C50.7458 43.9639 51.1721 43.5247 51.164 42.9908L50.6005 5.44936C50.5925 4.91552 50.1532 4.48925 49.6194 4.49726Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.8457,
    y: 16.0852,
    width: 32.1474,
    height: 14.4559,
    rx: 0.483357,
    transform: "rotate(-0.866421 14.8457 16.0852)",
    fill: "#BDC3C8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8457,
    y: 33.8818,
    width: 32.1474,
    height: 1.78535,
    rx: 0.483357,
    transform: "rotate(-0.866421 14.8457 33.8818)",
    fill: "#BDC3C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8457,
    y: 39.0098,
    width: 32.1474,
    height: 1.78535,
    rx: 0.483357,
    transform: "rotate(-0.866421 14.8457 39.0098)",
    fill: "#BDC3C8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5332,
    y: 9.89209,
    width: 6.09886,
    height: 1.78535,
    rx: 0.483357,
    transform: "rotate(-0.866421 23.5332 9.89209)",
    fill: "#BDC3C8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4592,
    cy: 10.5247,
    r: 2.65846,
    fill: "#8E9EAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3987 50.6512L60.3792 49.4858L57.4673 48.3473L56.282 45L55.1264 48.2634L52 49.4858L55.195 50.735L56.282 53.8047L57.3987 50.6512Z",
    fill: "#BDC3C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12029_80955",
    x1: 25.0115,
    y1: -108.874,
    x2: 32,
    y2: 89.5632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADB9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4F6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPublishedPosts);
export default __webpack_public_path__ + "static/media/no-published-posts.b00c1e7dd4ecd519b9ffb57f5dd830d2.svg";
export { ForwardRef as ReactComponent };